import { Image } from "antd";
import { FC } from "react";
import { GImageProps } from "../../../lib/types/shared/reactInherited";

const G_Image: FC<GImageProps> = ({
  alt = "",
  width = 100,
  height = width || 100,
  src = "",
  className,
  ...rest
}) => {
  return (
    <Image
      src={src}
      width={width}
      height={height}
      alt={alt}
      preview={false}
      className={className}
      {...rest}
    />
  );
};

export default G_Image;
